import { CAMERA_MOVIE_TYPE } from "@/config/const";

const cameraConnectingMessages = {
  1: {
    msg:"カメラに接続中..."
  },
  2: {
    msg:"レーダーに接続中..."
  },
  4: {
    msg:"カメラに接続中..."
  },
  5: {
    msg:"レーダーに接続中..."
  },  
  8: {
    msg:"カメラに接続中..."
  },
}

const cameraErrorMessages = {
  1: {
    msg:"カメラに接続できませんでした"
  },
  2: {
    msg:"レーダーに接続できませんでした"
  },
  4: {
    msg:"カメラに接続できませんでした"
  },
  5: {
    msg:"レーダーに接続できませんでした"
  },
}
const playerOptions = {
  1: {
    aspectRatio: "16:9",
    autoplay: false,
    muted: true,
    controls: true,
    preload: "auto",
    fullscreen: false,
    bigPlayButton: true,
    flash: { vhs: { withCredentials: false } },
    html5: { vhs: { withCredentials: false } },
    language: "ja",
    languages: {
      ja: {
        Play: "再生",
        "The media could not be loaded, either because the server or network failed or because the format is not supported.":
          "ネットワークに障害が発生したか、カメラが停止したため、再生できません"
      }
    },
    controlBar: { pictureInPictureToggle: false }
  },
  2: {
    fluid: true,
    autoplay: false,
    muted: true,
    controls: true,
    preload: "auto",
    fullscreen: false,
    bigPlayButton: true,
    flash: { vhs: { withCredentials: false } },
    html5: { vhs: { withCredentials: false } },
    language: "ja",
    languages: {
      ja: {
        Play: "再生",
        "The media could not be loaded, either because the server or network failed or because the format is not supported.":
          "ネットワークに障害が発生したか、レーダーが停止したため、再生できません"
      }
    },
    controlBar: {
      pictureInPictureToggle: false,
      volumePanel: false
    }
  },
  4: {
    aspectRatio: "16:9",
    autoplay: false,
    muted: true,
    controls: true,
    preload: "auto",
    fullscreen: false,
    bigPlayButton: true,
    flash: { vhs: { withCredentials: false } },
    html5: { vhs: { withCredentials: false } },
    language: "ja",
    languages: {
      ja: {
        Play: "再生",
        "The media could not be loaded, either because the server or network failed or because the format is not supported.":
          "ネットワークに障害が発生したか、カメラが停止したため、再生できません"
      }
    },
    controlBar: { pictureInPictureToggle: false }
  },
  5: {
    fluid: true,
    autoplay: false,
    muted: true,
    controls: true,
    preload: "auto",
    fullscreen: false,
    bigPlayButton: true,
    flash: { vhs: { withCredentials: false } },
    html5: { vhs: { withCredentials: false } },
    language: "ja",
    languages: {
      ja: {
        Play: "再生",
        "The media could not be loaded, either because the server or network failed or because the format is not supported.":
          "ネットワークに障害が発生したか、レーダーが停止したため、再生できません"
      }
    },
    controlBar: {
      pictureInPictureToggle: false,
      volumePanel: false
    }
  },
  6: {
    aspectRatio: "16:9",
    autoplay: false,
    muted: true,
    controls: true,
    preload: "auto",
    fullscreen: false,
    bigPlayButton: true,
    flash: { vhs: { withCredentials: false } },
    html5: { vhs: { withCredentials: false } },
    language: "ja",
    languages: {
      ja: {
        Play: "再生",
        "The media could not be loaded, either because the server or network failed or because the format is not supported.":
          "ネットワークに障害が発生したか、カメラが停止したため、再生できません"
      }
    },
    controlBar: { pictureInPictureToggle: false }
  },
  8: {
    autoplay: true,
    controls: false,
    responsive: true,
    fluid: true,
    muted: true,
    preload: "auto",
    fullscreen: false,
    bigPlayButton: true,
    flash: { vhs: { withCredentials: false } },
    html5: { vhs: { withCredentials: false } },
    language: "ja",
    languages: {
      ja: {
        Play: "再生",
        "The media could not be loaded, either because the server or network failed or because the format is not supported.":
          "カメラに接続できませんでした"
      }
    },
    controlBar: {
      pictureInPictureToggle: false,
      volumePanel: false
    }
  },
};

export default {
  data() {
    return {
      CAMERA_MOVIE_TYPE: CAMERA_MOVIE_TYPE
    };
  },
  methods: {
    getPlayerOption(type) {
      return playerOptions[type] || {};
    },
    getCameraConnectingMessage(type){
      return cameraConnectingMessages[type] && cameraConnectingMessages[type].msg || "";
    },
    getCameraErrorMessage(type){
      return cameraErrorMessages[type] && cameraErrorMessages[type].msg || "";
    }
  }
};
